
import { initWS } from '@/plugins/WSocket'

export default {
  namespaced: true,
  state: {
    ws: null
  },
  mutations: {
    setWebSocket (state, ws) {
      state.ws = ws
    }
  },
  actions: {
    async initWebSocket ({ commit }, token) {
      const ws = initWS(token)
      commit('setWebSocket', ws)
    }
  }
}
